var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCohortInstitution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16669 19.25H10.6667V33.25H7.16669V19.25Z",
    fill: "#619BF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4167 19.25H22.9167V33.25H19.4167V19.25Z",
    fill: "#619BF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 19.25H35.1667V33.25H31.6667V19.25Z",
    fill: "#619BF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 15.75V19.25C12.4167 19.4821 12.3245 19.7046 12.1604 19.8687C11.9963 20.0328 11.7738 20.125 11.5417 20.125H6.29169C6.05962 20.125 5.83706 20.0328 5.67297 19.8687C5.50887 19.7046 5.41669 19.4821 5.41669 19.25V15.75H12.4167Z",
    fill: "#3A82F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 36.75V33.25C12.4167 33.0179 12.3245 32.7954 12.1604 32.6313C11.9963 32.4672 11.7738 32.375 11.5417 32.375H6.29169C6.05962 32.375 5.83706 32.4672 5.67297 32.6313C5.50887 32.7954 5.41669 33.0179 5.41669 33.25V36.75H12.4167Z",
    fill: "#3A82F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 15.75V19.25C24.6667 19.4821 24.5745 19.7046 24.4104 19.8687C24.2463 20.0328 24.0238 20.125 23.7917 20.125H18.5417C18.3096 20.125 18.0871 20.0328 17.923 19.8687C17.7589 19.7046 17.6667 19.4821 17.6667 19.25V15.75H24.6667Z",
    fill: "#3A82F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 36.75V33.25C24.6667 33.0179 24.5745 32.7954 24.4104 32.6313C24.2463 32.4672 24.0238 32.375 23.7917 32.375H18.5417C18.3096 32.375 18.0871 32.4672 17.923 32.6313C17.7589 32.7954 17.6667 33.0179 17.6667 33.25V36.75H24.6667Z",
    fill: "#3A82F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9167 15.75V19.25C36.9167 19.4821 36.8245 19.7046 36.6604 19.8687C36.4963 20.0328 36.2738 20.125 36.0417 20.125H30.7917C30.5596 20.125 30.3371 20.0328 30.173 19.8687C30.0089 19.7046 29.9167 19.4821 29.9167 19.25V15.75H36.9167Z",
    fill: "#3A82F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9167 36.75V33.25C36.9167 33.0179 36.8245 32.7954 36.6604 32.6313C36.4963 32.4672 36.2738 32.375 36.0417 32.375H30.7917C30.5596 32.375 30.3371 32.4672 30.173 32.6313C30.0089 32.7954 29.9167 33.0179 29.9167 33.25V36.75H36.9167Z",
    fill: "#3A82F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 35.875H3.66669C3.18344 35.875 2.79169 36.2668 2.79169 36.75V38.5C2.79169 38.9832 3.18344 39.375 3.66669 39.375H38.6667C39.1499 39.375 39.5417 38.9832 39.5417 38.5V36.75C39.5417 36.2668 39.1499 35.875 38.6667 35.875Z",
    fill: "#3A82F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 2.625L2.79169 16.625H39.5417L21.1667 2.625Z",
    fill: "#3A82F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 13.125C22.6164 13.125 23.7917 11.9497 23.7917 10.5C23.7917 9.05025 22.6164 7.875 21.1667 7.875C19.7169 7.875 18.5417 9.05025 18.5417 10.5C18.5417 11.9497 19.7169 13.125 21.1667 13.125Z",
    fill: "#FCD770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohortInstitution);
export default __webpack_public_path__ + "static/media/cohort_institution.89949770c3ed480aacef92015f1d4c6a.svg";
export { ForwardRef as ReactComponent };